<script setup lang="ts">
import { type ShallowRef, shallowRef, watchEffect } from 'vue'

import { EVariants } from '../../composables/useCreateComponentConfig'

import { EBadgePlacement, type IBadgeConfig, type IBadgeProps } from './types'
import { useBadgeConfig } from './composables/useBadgeConfig'
import { isDark } from '@/lib/utils'
import { ICON_SIZES, SIZES } from '@/ui/ts/types/Sizes'

const props = withDefaults(defineProps<IBadgeProps>(), {
    variant: EVariants.PRIMARY,
    size: SIZES.MEDIUM,
    disabled: false,
    dark: false,
    placement: EBadgePlacement.DEFAULT,
})
const iconSizeMapping = {
    [SIZES.XSMALL]: ICON_SIZES.XSMALL,
    [SIZES.SMALL]: ICON_SIZES.XSMALL,
    [SIZES.MEDIUM]: ICON_SIZES.SMALL,
    [SIZES.LARGE]: ICON_SIZES.MEDIUM,
}

const badgeConfig: ShallowRef<IBadgeConfig> = shallowRef({})

watchEffect(() => {
    badgeConfig.value = useBadgeConfig(props)
})
</script>

<template>
    <div
        class="v-badge"
        :class="[isDark(dark), badgeConfig.rootClasses]"
        :data-test="`badge-${dataTest}`"
        data-gpp-tools-ui
    >
        <VIcon
            v-if="icon"
            :name="icon"
            :size="iconSizeMapping[props.size]"
        />

        <slot name="content">
            <span class="truncate"><slot /></span>
        </slot>
    </div>
</template>
